import React, { createContext, Component } from 'react';

// Création d'un contexte global
export const GlobalContext = createContext();
export const UploadComponentRef = React.createRef();
export const SideBarRef = React.createRef();
export const WorkerTasksComponentRef = React.createRef();



export class GlobalProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      language: localStorage.getItem("current-language"),
      setLanguage: this.setLanguage // Méthode pour mettre à jour la variable globale
    };
  }

  // Set Languae
  setLanguage = (newValue) => {
    this.setState({ language: newValue });
  }

  render() {
    return (
      <GlobalContext.Provider value={this.state}>
        {this.props.children}
      </GlobalContext.Provider>
    );
  }
}